import Rekv from "../Rekv";

const counterStore = new Rekv({
  count: 0
});

export default counterStore;

function incr(n: number) {
  counterStore.setState((s) => ({ count: s.count + n }));
}
export function add() {
  incr(1);
}
export function minus() {
  incr(-1);
}
export function addAfter1s() {
  setTimeout(() => incr(5), 1000);
}
export function minusAfter1s() {
  setTimeout(() => incr(-5), 1000);
}
export function reset() {
  counterStore.setState({ count: 0 });
}
